import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformServer } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  DOCUMENT
} from '@angular/core';
import { BloomreachComponent } from '@app/shared/base-classes/bloomreach-component';
import { StorageService } from '@core/services';
import { Colors, breakpoints } from '@shared/constants';
import { GlobalFooterMapper } from './global-footer.mapper';
import { resolveResourceBundleArray } from '@app/core/bloomreach';

@Component({
    selector: 'mflooring-global-footer',
    templateUrl: './global-footer.component.html',
    styleUrls: ['./global-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GlobalFooterComponent
	extends BloomreachComponent
	implements OnInit
{
	public isMobile: boolean;
	public layoutContainerProp = {
		content: {
			backgroundColor: Colors.white,
		},
	};
	handleSSRClass = '';

	@HostListener('window:resize') onResize() {
		this.isMobile = this.breakpoint.isMatched(breakpoints.mobileMaxfooter);

		return this.isMobile;
	}

	constructor(
		public storage: StorageService,
		private breakpoint: BreakpointObserver,
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(PLATFORM_ID) private platformId: string
	) {
		super(storage);
		if (isPlatformServer(this.platformId)) {
			this.handleSSRClass = 'inset';
		} else {
			this.handleSSRClass = '';
		}
	}

	get pageTitleVisDemo() {
		return this.documentRef.title?.split(' ')?.[0];
	}

	get isInset() {
		return !this.isMobile;
	}

	get footerData(): {
		logo: any;
		copyright: any;
		termsOfUse: any;
		privacyPolicy: any;
		retailStores: any;
		search: any;
		socialMedia: any;
	} {
		
	
		
		const test = GlobalFooterMapper(this.resourceBundleData);
		return test;
	}

	ngOnInit() {
		this.isMobile = this.onResize();
	}
}
